import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Base64 } from 'js-base64';
import $ from "jquery";
import { JurPerson } from '../../@core/data/jur-person';
import { AuthGuardService } from '../../@core/utils/auth-guard-service.service';

import { NbThemeService } from '@nebular/theme';
import { RestService } from '../../@core/utils/rest.service';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { formatDate } from '@angular/common';
import { Result } from '../../@core/data/result';
import Swal from 'sweetalert2';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { FormArrayName } from '@angular/forms';
import { Jsonp } from '@angular/http';
declare let X2JS: any;


@Component({
  selector: "ngx-cabinet",
  templateUrl: "./cabinet.component.html",
  styleUrls: ["./cabinet.component.scss"],
})
export class CabinetComponent implements OnInit {
  public jurPerson: JurPerson
  curUSD: any;
  curRUB: any;
  curEUR: any;
  changeUSD: any;
  changeRUB: any;
  changeEUR: any;
  today = new Date();
  PHONE: string = '';
  KBE: string;
  data1: string;
  SECO: string;
  todayjs: string;
  address: any;
  nameCompany: any;
  email: any;
  contact: any;
  oked: any;
  ind: any;
  chief: any;
  reciver: any[];
  title: string;
  idn: any;
  token: any;
  saveButtonDisabled: boolean = false;
  hasError: any;
  managerAppointment: any;
  managerFullname: any;
  managerPhone: any;
  constructor(private themeService: NbThemeService, public rest: RestService, private router: Router, public auth: AuthGuardService, public translate: TranslateService, public httpClient: HttpClient) { }

  ngOnInit() {

    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };

    try {

      if (!sessionStorage.getItem('jurPerson')) {
        Swal.fire({
          text: this.translate.instant('ALERTNOSERVICE'),
          type: 'error',
          confirmButtonText: 'OK',
          confirmButtonColor: "#008e54"
        })
        this.router.navigate(['/auth/login']);
      }
      else {

        this.rest.getJurPerson(sessionStorage.getItem('jurPerson')).subscribe((data: Result) => {

          if (data.code == '0') {
            let base64 = data.message.toString();
            let jsonString = Base64.decode(base64);
            let pers = JSON.parse(jsonString);
            console.log(pers)
            // console.log("Madi : " + jsonString);
            this.token = JSON.parse(sessionStorage.getItem('jurPerson')).token;
            this.jurPerson = pers;
            sessionStorage.setItem('persons', JSON.stringify(this.jurPerson.persons));
            this.address = pers.address;
            // this.nameCompany = JSON.parse(pers.NAME_JUR);
            this.nameCompany = pers.NAME_JUR;
            this.idn = pers.IDN;
            this.chief = pers.CHIEF;
            this.email = pers.email;
            this.contact = pers.phone;
            this.oked = pers.oked;
            this.managerAppointment = pers.manager_appointment;
            this.managerFullname = pers.manager_fullname;
            this.managerPhone = pers.manager_phone;

            if (pers.KBE == undefined) {
              sessionStorage.setItem("KBE", isNaN(pers.IRS + pers.SECO) == true ? null : (pers.IRS + pers.SECO));

            }

            sessionStorage.setItem("jurName", this.nameCompany);
            sessionStorage.setItem('bicBank', this.jurPerson.BANK_BIK);
            sessionStorage.setItem('binBank', this.jurPerson.BANK_BIN);
            sessionStorage.setItem('IDN', this.jurPerson.IDN);
            //sessionStorage.setItem('EMAIL', pers.email);

          //  sessionStorage.setItem("ADDRESS", pers.address);
            sessionStorage.setItem("address", pers.address)
            sessionStorage.setItem("nameJur", this.jurPerson.NAME_JUR);
            sessionStorage.setItem("email", this.email);
            sessionStorage.setItem("contact", pers.phone);
            sessionStorage.setItem("oked", pers.oked);
            sessionStorage.setItem("LANGUAGE", pers.language);
            sessionStorage.setItem("nameCompany", this.nameCompany);
            sessionStorage.setItem("BANK", pers.BANK);
            sessionStorage.setItem('BANK_IBAN', pers.BANK_IBAN);
            sessionStorage.setItem("CHIEF", pers.CHIEF);
            sessionStorage.setItem("CTZN", pers.CTZN);
            sessionStorage.setItem("ID_JUR", pers.ID_JUR);
            sessionStorage.setItem("IRS", pers.IRS);
            sessionStorage.setItem("MAINBK", pers.MAINBK);
            sessionStorage.setItem("SECO", pers.SECO);
            sessionStorage.setItem("IIN", pers.iin);
            if(!sessionStorage.getItem('jurPersonAccess')){
              Swal.fire({
                title: this.translate.instant('ACCESSMODALTITLE'),
                html: this.translate.instant('ACCESSMODALTEXT'),
                confirmButtonText: 'OK',
                confirmButtonColor: "#008e54",
                width: '1130px'
              });
              sessionStorage.setItem("jurPersonAccess", "1");
            }

            //Получение данные получателя
            this.rest.getRecieverData().subscribe((data: any) => {
              this.reciver = [];
              this.reciver = JSON.parse(JSON.stringify(data)).message;
              sessionStorage.setItem('reciverData', JSON.stringify(this.reciver));

            },
              error => {
                this.title = JSON.stringify(error);
              });

            this.todayjs = formatDate(this.today, 'dd.MM.yyyy', 'en-US');
            this.KBE = isNaN(pers.IRS + pers.SECO) == true ? null : (pers.IRS + pers.SECO);



            this.rest.getCurrentcyList().toPromise().then((res: any) => {

              if (res.code == 0) {
                let json = JSON.parse(Base64.decode(res.message));

                console.log(json)

                for (let i = 0; i < json.item.length; i++) {
                  if (json.item[i].title == 'USD') {
                    this.curUSD = json.item[i].description / json.item[i].quant;
                    this.changeUSD = json.item[i].change;

                    if (json.item[i].index == 'UP') {
                      document.getElementById("changeUSD").style.color = "green";
                      document.getElementById("iconUSD").className = "fas fa-arrow-up";
                    }
                    if (json.item[i].index == 'DOWN') {
                      document.getElementById("changeUSD").style.color = "red";
                      document.getElementById("iconUSD").className = "fas fa-arrow-down";
                    }
                  }

                  if (json.item[i].title == 'EUR') {
                    this.curEUR = json.item[i].description / json.item[i].quant;
                    this.changeEUR = json.item[i].change;
                    if (json.item[i].index == 'UP') {
                      document.getElementById("changeEUR").style.color = "green";
                      document.getElementById("iconEUR").className = "fas fa-arrow-up";
                    }
                    if (json.item[i].index == 'DOWN') {
                      document.getElementById("changeEUR").style.color = "red";
                      document.getElementById("iconEUR").className = "fas fa-arrow-down";
                    }
                  }
                  if (json.item[i].title == 'RUB') {
                    this.curRUB = json.item[i].description / json.item[i].quant;
                    this.changeRUB = json.item[i].change;

                    if (json.item[i].index == 'UP') {
                      document.getElementById("changeRUB").style.color = "green";
                      document.getElementById("iconRUB").className = "fas fa-arrow-up";

                    }
                    if (json.item[i].index == 'DOWN') {
                      document.getElementById("changeRUB").style.color = "red";
                      document.getElementById("iconRUB").className = "fas fa-arrow-down";
                    }
                  }
                }
              }
            }).catch((err) => {
              console.error(err)
            })


          }
          if (data.code == '-4') {
            Swal.fire({
              text: data.message,
              type: 'warning',
              confirmButtonText: 'OK',
              confirmButtonColor: "#008e54"
            })
            sessionStorage.setItem('jurPerson', '');
            this.router.navigate(['/auth']);
            sessionStorage.setItem('jurName', '');
          }
          if (data.code == '-1') {
            sessionStorage.setItem('errorMessage', data.message);
            sessionStorage.setItem('jurPerson', '');
            sessionStorage.setItem('jurName', '');
            console.error('error - 2 - ' + data.message);
            Swal.fire({
              text: data.message,
              type: 'error',
              confirmButtonText: 'OK',
              confirmButtonColor: "#008e54"
            })
          }
        });
      }
    }
    catch (e) {
      console.error(e.message);
      Swal.fire({
        text: this.translate.instant('ALERTNOSERVICE'),
        type: 'error',
        confirmButtonText: 'OK',
        confirmButtonColor: "#008e54"
      })
    }
    // earning-card

  }


  async getTest() {

    this.saveButtonDisabled = true;
    let parser, fio, bin, contact, email, oked, ind, xml, resXml, workName, leaderMiddleName, leaderName, leaderSurname, baseWorkName, baseFio, address


      try {
        let re = await this.rest.getUserAddress('200140037985', 'ru').toPromise();
        address = re['obj']['katoAddress'] ? re['obj']['katoAddress'] : this.address;
      } catch (error) {
        console.error("Ошибка при получении адреса:", error);
        this.hasError = true;
      }




    // try {
    //  await this.rest.getUserAddress('200140037985', 'ru').subscribe(data => {
    //     address = data['obj']['katoAddress'] ? data['obj']['katoAddress'] : this.address;
    //     console.log('2')
    //   }, error => {
    //     alert('33')
    //     this.hasError = true;
    //   })
    // } catch (error) {
    //   console.log('2')
    //   alert(12312)
    // }




    let res = this.httpClient.get("https://gbdul.enpf.kz/sendMessage?bin=200140037985", { responseType: 'text' })
      .subscribe(async data => {
        parser = new DOMParser();
        xml = parser.parseFromString(data, 'application/xml')
        resXml = parser.parseFromString(xml.getElementsByTagName('data')[0].firstChild.nodeValue, 'application/xml')
        workName = resXml.getElementsByTagName('orgShortNameRu')[0].firstChild.nodeValue
        leaderName = resXml.getElementsByTagName('leaderPerson')[0].getElementsByTagName('Name')[0].firstChild.nodeValue
        leaderSurname = resXml.getElementsByTagName('leaderPerson')[0].getElementsByTagName('SurName')[0].firstChild.nodeValue
        leaderMiddleName = resXml.getElementsByTagName('leaderPerson')[0].getElementsByTagName('MiddleName')[0].firstChild.nodeValue
        fio = leaderSurname + ' ' + leaderName + ' ' + leaderMiddleName
        bin = resXml.getElementsByTagName('IINBIN')[0].firstChild.nodeValue
        oked = resXml.getElementsByTagName('OKED')[0].firstChild.nodeValue
        baseFio = document.getElementsByClassName('chief')[0].innerHTML
        baseWorkName = document.getElementsByClassName('nameCompany')[0].innerHTML

        if (this.chief != fio || this.nameCompany != workName || this.address != address || this.oked != oked) {
          this.chief = fio
          this.nameCompany = workName
          this.address = address ? address : this.address
          this.oked = oked

          if (!this.jurPerson) {
            console.error("Ошибка: this.jurPerson не определен!", this.jurPerson);
            Swal.fire({
              text: "Ошибка: данные о компании не загружены",
              type: 'error',
              confirmButtonText: 'OK'
            });
            return;
          }
          let jsonJurData = {
            "jur_person": this.jurPerson.ID_JUR,
            "idn": this.jurPerson.IDN,
            "name_jur": workName,
            "address": this.address,
            "chief": fio,
            "mainbk": this.jurPerson.MAINBK,
            "irs": this.jurPerson.IRS,
            "seco": this.jurPerson.SECO,
            "ctzn": this.jurPerson.CTZN,
            "bin": this.jurPerson.BANK_BIN,
            "bic": this.jurPerson.BANK_BIK,
            "iban": sessionStorage.getItem("BANK_IBAN"),
            "nameBank": this.jurPerson.BANK,
            "token": this.token,
            "lang": sessionStorage.getItem("LANGUAGE"),
            "iin": sessionStorage.getItem("IIN"),
            "email": this.jurPerson.email,
            "contacts": sessionStorage.getItem("contact"),
            "oked": oked
          }

          const res = await this.rest.saveJurPerson(JSON.stringify(jsonJurData), {
            headers: { 'Content-Type': 'application/json' }
          }).toPromise();
          
            if (res.code == "0") {
              console.log('ok')
            }
            if (res.code == "-1") {
              console.log('res' + res);
              this.hasError = true;
              console.log('log 1 ',this.hasError);
            }

          if (this.hasError == false) {
            Swal.fire({
              text: this.translate.instant('ALERTTECHNICAL'),
              type: 'error',
              confirmButtonText: 'OK'
            })
          } else {
            Swal.fire({
              text: "Данные обновлены",
              type: 'success',
              confirmButtonText: 'OK',
              confirmButtonColor: "#008e54"
            }
            )
          }
        }
        else {
          Swal.fire({
            text: "Данные актульаны",
            type: 'success',
            confirmButtonText: 'OK',
            confirmButtonColor: "#008e54"
          }
          )
        }
        this.saveButtonDisabled = false;
      }, error => {
        Swal.fire({
          text: this.translate.instant('ALERTTECHNICAL'),
          type: 'error',
          confirmButtonText: 'OK'
        })
      })
      

  }

}

